import { render, staticRenderFns } from "./MarkdownRenderer.vue?vue&type=template&id=5608167e&scoped=true&"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=ts&"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownRenderer.vue?vue&type=style&index=0&id=5608167e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608167e",
  null
  
)

export default component.exports